module.exports = __webpack_public_path__ + "static/media/img-9d0c623b-b2de-11ed-817c-0a1ea4c5532f.e19029ae.png";